import { useMutation, UseMutationOptions } from "react-query";
import { fetchApi } from "../../../helpers/reactQueryApi";
import {
  ActivityReply,
  FileAttachment,
  ImageAttachment,
} from "../../../@types/activities.ts";

/* Replies */
export function createComment({ activityId, type = "replies", ...body }) {
  return fetchApi(`/api/v1/activities/${activityId}/${type}`, {
    method: "POST",
    body,
  });
}
export function useCreateComment(
  options?: UseMutationOptions<
    ActivityReply & { i: { can: ActivityReply["can"] } },
    Error,
    {
      activityId: string;
      type: string;
      content: string;
      files: string[];
      images: string[];
      quotedReplyId?: string;
    }
  >,
) {
  return useMutation(createComment, options);
}

export function updateComment({
  activityId,
  replyId,
  type = "replies",
  ...body
}) {
  return fetchApi(`/api/v1/activities/${activityId}/${type}/${replyId}`, {
    method: "PUT",
    body,
  });
}
export function useUpdateComment(
  options?: UseMutationOptions<
    Omit<ActivityReply, "attachments"> & {
      i: { can: ActivityReply["can"] };
      attachments: ((FileAttachment | ImageAttachment) & {
        sources: { url: string; width: number; height: number }[];
        type: string;
      })[];
    },
    Error,
    {
      activityId: string;
      replyId: string;
      type: string;
      content: string;
      files: string[];
      images: string[];
      quotedReplyId?: string;
    }
  >,
) {
  return useMutation(updateComment, options);
}
